import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Composant de redirection vers l'onglet Historique de la page Santé
 */
const RedirectToHistory = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/health', { 
      state: { defaultTab: 'history' },
      replace: true 
    });
  }, [navigate]);

  return null;
};

export default RedirectToHistory;
